import spinner from "../assets/svg/spinner.svg";
export default function Spinner() {
  return (
    <div className="loading-overlay">
      <div>
        <img src={spinner} alt="Loading..." className="loading-spinner" />
      </div>
    </div>
  );
}
